import React from 'react'
import { Check } from 'lucide-react'

export const WhyNuBrakes = () => {
  const benefits = [
    {
      title: 'WE COME TO YOU',
      description:
        "Don't waste hours sitting at a shop. We deliver ultra-convenient repairs right where you're parked at your home or office.",
    },
    {
      title: 'EXPERIENCED MECHANICS',
      description:
        "We don't work with third-party mechanics. Our mechanics are full-time NuBrakes employees with decades of experience working on vehicles.",
    },
    {
      title: 'SAME-DAY AVAILABILITY',
      description:
        'Need your brakes repaired today? Same-day service is typically available — contact us to schedule!',
    },
  ]
  return (
    <section className="w-full bg-white py-8">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl text-center mb-8">WHY NUBRAKES?</h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {benefits.map((benefit, index) => (
            <div
              key={index}
              className="flex flex-col items-center md:items-start"
            >
              <div className="flex items-center mb-3">
                <div className="w-8 h-8 rounded-full bg-green-300 flex items-center justify-center mr-2">
                  <Check />
                </div>
                <h3 className="text-lg">{benefit.title}</h3>
              </div>
              <p className="text-gray-700 text-center md:text-left">
                {benefit.description}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}
